import React, { useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import cabinetImg1 from 'assets/images/starters/cabinetImg1.png';
import cabinetImg2 from 'assets/images/starters/cabinetImg2.png';
import cabinetImg3 from 'assets/images/starters/cabinetImg3.png';
import cabinetImg4 from 'assets/images/starters/cabinetImg4.png';
import cabinetImg5 from 'assets/images/starters/cabinetImg5.png';
import cabinetImg6 from 'assets/images/starters/cabinetImg6.png';
import { loadFurnitureAction } from '../Configurator/actions/furniture';
import {
  BASE_CABINET,
  BASE_HANG_CABINET,
  BASE_SHELF_CABINET,
  BASE_SHOWCASE_CABINET,
  BASE_TRIPLE_SHELF_CABINET,
  BASE_WARDROBE_CABINET,
} from '../Configurator/constants/furniture';
import { FiArchive, FiDownload } from 'react-icons/all';

interface Props {
  setShowTypeSelector: any;
}

const TypeCabinetModalSelector = ({ setShowTypeSelector }: Props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [previousFurniture, setPreviousFurniture] = useState<boolean>(false);

  const closeModal = () => {
    setShowTypeSelector(false);
  };

  useEffect(() => {
    hasFurnitureInLocalStorage();
  }, []);

  const onClose = () => {
    closeModal();
  };

  const hasFurnitureInLocalStorage = () => {
    const furniture = localStorage.getItem('furniture');
    if (furniture) {
      setPreviousFurniture(true);
    }
  };

  return (
    <div>
      <Modal
        open={true}
        onClose={onClose}
        center
        closeOnOverlayClick={false}
        showCloseIcon={false}
        closeOnEsc={false}
        focusTrapped={false}
      >
        <div className="flex flex-col items-center justify-center">
          <div className="p-5 text-2xl ">
            {t('What type of furniture do you want to configure')}
          </div>
          <div className="border-b" />
          <div className="flex">
            <button
              className="flex flex-col items-center justify-between m-2 p-2 hover:border hover:border-blue hover:border-4"
              onClick={() => {
                dispatch(loadFurnitureAction(BASE_CABINET));
                onClose();
              }}
            >
              <img src={cabinetImg1} className="w-full h-full" alt="cabinet" />
              <div className="-ml-10 text-lg font-normal">
                {t('Low cabinet')}
              </div>
            </button>
            <button
              className="flex flex-col items-center justify-between m-2 p-2 hover:border-blue hover:border-4"
              onClick={() => {
                dispatch(loadFurnitureAction(BASE_TRIPLE_SHELF_CABINET));
                onClose();
              }}
            >
              <img src={cabinetImg2} className="w-full h-full" alt="shelf" />
              <div className="-ml-10 text-lg font-normal">
                {t('starters.Cabinet')}
              </div>
            </button>

            <button
              className="flex flex-col items-center justify-center m-2 p-2 hover:border-blue hover:border-4"
              onClick={() => {
                dispatch(loadFurnitureAction(BASE_WARDROBE_CABINET));
                onClose();
              }}
            >
              <img src={cabinetImg3} className="w-full h-full" alt="shelf" />
              <div className="-ml-10 text-lg font-normal">{t('Wardrobe')}</div>
            </button>
          </div>

          <div className="flex">
            <button
              className="flex flex-col items-center justify-center m-2 p-2 hover:border-blue hover:border-4"
              onClick={() => {
                dispatch(loadFurnitureAction(BASE_SHOWCASE_CABINET));
                onClose();
              }}
            >
              <img src={cabinetImg4} className="w-full h-full" alt="shelf" />
              <div className="-ml-10 text-lg font-normal">{t('Display cabinet')}</div>
            </button>

            <button
              className="flex flex-col items-center justify-center m-2 p-2 hover:border-blue hover:border-4"
              onClick={() => {
                dispatch(loadFurnitureAction(BASE_SHELF_CABINET));
                onClose();
              }}
            >
              <img src={cabinetImg5} className="w-full h-full" alt="shelf" />
              <div className="-ml-10 text-lg font-normal">{t('Bookshelf')}</div>
            </button>
            <button
              className="flex flex-col items-center justify-center m-2 p-2 hover:border-blue hover:border-4"
              onClick={() => {
                dispatch(loadFurnitureAction(BASE_HANG_CABINET));
                onClose();
              }}
            >
              <img src={cabinetImg6} className="w-full h-full" alt="shelf" />
              <div className="-ml-10 text-lg font-normal">
                {t('Hanging cabinet')}
              </div>
            </button>
          </div>

          {previousFurniture && (
            <div className="flex flex-col items-center justify-center mt-2">
              <div className="w-full border-b" />
              <div className="py-4 text-xl">ou</div>

              <div>
                <button
                  className="kewconf-btn-cart bg-gray-800 text-white px-2 py-2 text-xl my-2 flex items-center justify-center rounded rounded-r-md w-full mx-2"
                  onClick={() => {
                    dispatch(loadFurnitureAction());
                  }}
                >
                  <FiArchive className="h-8 w-8 mr-4" />
                  {t('Continue my project ')}
                </button>
              </div>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default TypeCabinetModalSelector;
